import React, { useEffect, useRef, useState } from "react";
import { Column, Button } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { selectTaxonomyAdmin, selectTaxonomyAdminLoading } from "../../redux/taxonomyAdmin/selectors";
import { getTaxonomiesAdminPaginated, createTaxonomyAdmin, updateTaxonomyAdmin, deleteTaxonomyAdmin } from "../../redux/taxonomyAdmin/thunks";
import { Typography } from "@material-ui/core";
import { SelectBox, CheckBox, TagBox, NumberBox } from "devextreme-react";
import AdminDialog from "./AdminDialog";
import { openModal } from "../../redux/modal/modalSlice";
import { selectTaxonomyDescriptions } from "../../redux/taxonomyDescriptions/selectors";
import { getTaxonomyDescriptions } from "../../redux/taxonomyDescriptions/thunks";
import { makeStyles } from '@material-ui/core/styles';
import { selectAllInteraction } from "../../redux/interactions/selectors";
import { getInteractions } from "../../redux/interactions/thunks";
import { selectCaseStates } from "../../redux/caseStates/selectors";
import { getCaseStates } from "../../redux/caseStates/thunks";
import { postTaxonomy } from "../../redux/taxonomies/thunks";
import { selectTaxonomy } from "../../redux/taxonomies/selectors";


const initialDialogState = {operation: "", title: "", selectedId: null, data: "", open: false, onClose: null, openDialog: null, handleChange: null}

const formInitialState = {
    taxonomyLevel1 : "",
    taxonomyLevel2 : "",
    taxonomyLevel3 : "",
    taxonomyLevel4 : "",
    slaHours: null,
    isVisible : true,
    interactions: [],
    validStates: []
}
const initialFilterValues = {
    level: 1,
    taxonomyLevel_1: null,
    taxonomyLevel_2: null,
    taxonomyLevel_3: null,
    taxonomyLevel_4: null
}

const useStyles = makeStyles({
    label: {
        color: "#333"
    },
  });

function InputWrapper(props){
    const {classes, label} = props;
        return (
            <div className="dx-field">
                <label className={classes.label}>{label}</label> 
                <div style={{width:"50%"}} className="dx-field-value">
                    {props.children}
                </div>
            </div>
        )
}

const initialSortOptions = {
    columna: "taxonomyId",
    sortOrderAsc: false

}


function TaxonomyManagement () {
    const classes = useStyles();
    const dispatch = useDispatch();
    const taxonomies = useSelector(selectTaxonomyAdmin);
    const caseStates = useSelector(selectCaseStates);
    const taxonomyDescriptions = useSelector(selectTaxonomyDescriptions);
    const interactions = useSelector(selectAllInteraction);
    const loading = useSelector(selectTaxonomyAdminLoading);
    const numElements = [10, 20, 30];
    const [dataDialog, setDataDialog] = useState({...initialDialogState}); 
    const {operation, data, open, title, selectedId} = dataDialog;
    const [taxonomyForm, setTaxonomyForm] = useState(formInitialState);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    const filterOptions = useSelector(selectTaxonomy)
    const labelTaxonomyLevel1 = "Taxonomia N1";
    const labelTaxonomyLevel2 = "Taxonomia N2";
    const labelTaxonomyLevel3 = "Taxonomia N3";
    const labelTaxonomyLevel4 = "Taxonomia N4";
    const labelSLA = "SLA (Horas)"
    const labelVisible = "Visível"
    const labelInteraction = "Códigos de interação"
    const labelValidStates = "Status válidos"
    const [filterValues, setFilterValues] = useState(initialFilterValues)
    const filterLevel2 = useRef()
    const filterLevel3 = useRef()
    const filterLevel4 = useRef()

    useEffect (()=>{
        getTaxonomiesAdmin(mapPageInfo(taxonomies));
        dispatch(postTaxonomy({body: initialFilterValues}))
        dispatch(getTaxonomyDescriptions());
        dispatch(getInteractions());
        dispatch(getCaseStates());
    }, [])

    function mapPageInfo(taxonomiesData){
        return {
            pageIndex: taxonomiesData.pageIndex ?? 0,
            pageSize: taxonomiesData.pageSize ?? 10,
            orderByField: taxonomiesData.columna ?? "taxonomyId",
            orderByAscending: taxonomiesData.sortOrderAsc ?? true
        }
    }

    const getTaxonomiesAdmin = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
        {
            query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
        }
        if(filterValues !== initialFilterValues)
        {
            if(filterValues.taxonomyLevel_1) 
                query = query.concat(`&level1=${filterValues.taxonomyLevel_1}`)
            if(filterValues.taxonomyLevel_2) 
                query = query.concat(`&level2=${filterValues.taxonomyLevel_2}`)
            if(filterValues.taxonomyLevel_3) 
                query = query.concat(`&level3=${filterValues.taxonomyLevel_3}`)
            if(filterValues.taxonomyLevel_4) 
                query = query.concat(`&level4=${filterValues.taxonomyLevel_4}`)
        }
        dispatch(getTaxonomiesAdminPaginated({query}));
    }

    const handleDialogClose = () => {
        setDataDialog({...dataDialog, open: false});
    };

    const onChange = (name, value) => {
        setTaxonomyForm(form => ({...form, [name]: value}))
    }

    function onFilterChange(newValue, level){
            let newFilterValues = {...filterValues, level, [`taxonomyLevel_${level-1}`]: newValue }
            for(let i = level; i<5; i++){
                newFilterValues = {...newFilterValues, [`taxonomyLevel_${i}`]: null}
            }
            dispatch(postTaxonomy({body: newFilterValues}))
            setFilterValues(newFilterValues)
    }

    function handleChangeTaxonomy(name, e, resetLevelNo){
        if(e.value === null){
            for(let i = resetLevelNo; i<5; i++){
                setTaxonomyForm(form=> ({...form, [`taxonomyLevel${i}`]: ""}))
            }
        }
        onChange(name, e.value)
    }

    const handleSaveNew = (e) =>  {   
        if (taxonomyForm.taxonomyLevel1 !== "") {
            const params = {
                body:{
                    Level_1: taxonomyForm.taxonomyLevel1,
                    Level_2: taxonomyForm.taxonomyLevel2,
                    Level_3: taxonomyForm.taxonomyLevel3,
                    Level_4: taxonomyForm.taxonomyLevel4,
                    slaHours: taxonomyForm.slaHours,
                    isVisible: taxonomyForm.isVisible,
                    validStates: taxonomyForm.validStates,
                    interactions: taxonomyForm.interactions
                }
            }
            dispatch(createTaxonomyAdmin(params)).then((data) => {
                if (data.error)
                    dispatch(openModal({ type: "warning", message:data.error.message}))
                else {
                    getTaxonomiesAdmin(mapPageInfo({...taxonomies, ...sortOptions}));
                    dispatch(getTaxonomyDescriptions());
                    handleDialogClose();
                }                    
            })            
        } else {
            handleDialogClose();
        }       
    } 
    
    const handleSaveEdit = (e) => {
        if (taxonomyForm.taxonomyLevel1 !== "") {
            const params = {
                param: selectedId,
                body:{
                    Level_1: taxonomyForm.taxonomyLevel1,
                    Level_2: taxonomyForm.taxonomyLevel2,
                    Level_3: taxonomyForm.taxonomyLevel3,
                    Level_4: taxonomyForm.taxonomyLevel4,
                    slaHours: taxonomyForm.slaHours,
                    isVisible: taxonomyForm.isVisible,
                    validStates: taxonomyForm.validStates,
                    interactions: taxonomyForm.interactions
                }
            }
            dispatch(updateTaxonomyAdmin(params)).then((data) => {
                if (data.error)
                    dispatch(openModal({ type: "warning", message:data.error.message}))
                else {
                    getTaxonomiesAdmin(mapPageInfo({...taxonomies, ...sortOptions}));
                    dispatch(getTaxonomyDescriptions());
                    handleDialogClose();
                }                    
            })            
        } else {
            handleDialogClose();
        }  
    }

    const handleDelete = () => {
        dispatch(deleteTaxonomyAdmin({ param: selectedId })).then((data) => {
            if (data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else {
                let updatedPageIndex = taxonomies.pageIndex;

                if (taxonomies.elements.length === 1) {
                    updatedPageIndex = Math.max(0, taxonomies.pageIndex - 1);
                }

                const updatedTaxonomies = {
                    ...taxonomies,
                    pageIndex: updatedPageIndex,
                };

                getTaxonomiesAdmin(mapPageInfo({...updatedTaxonomies, ...sortOptions}));
                handleDialogClose();               
            }
        })  
    }

    const onSubmitOperation = (e) => {
        switch (operation) {
            case "create": 
                handleSaveNew(e);
                break;
            case "edit": 
                handleSaveEdit(e);
                break;
            case "delete": 
                handleDelete();
                break;
            default: break;
        }
    } 

    const handleCalculateStateCellDisplayValue = (rowData) => {
        return rowData.validStates.map(caseState => caseState.description).join(", ");
    }

    const handleCalculateInteractionCellDisplayValue = (rowData) => {
        return rowData.interactions.map(interaction => interaction.interactionCode).join(", ");
    }


    function handleEditValidStates(newValue){
        const updatedValues = newValue.length > 0 ? newValue : []
        onChange("validStates", updatedValues)
}

function handleEditInteractions(newValue){
    const updatedValues = newValue.length > 0 ? newValue : []
    onChange("interactions", updatedValues)
}

    function handleNewDialogOpen() {
        setTaxonomyForm(formInitialState);
        setDataDialog({title: "Criar Taxonomia", selectedId: null, data: "", open: true, operation: "create"})
    }

    function handleEditDialogOpen(e) {
        setTaxonomyForm({
            taxonomyLevel1: e.row.data.level_1,
            taxonomyLevel2: e.row.data.level_2,
            taxonomyLevel3: e.row.data.level_3,
            taxonomyLevel4: e.row.data.level_4,
            slaHours: e.row.data.slaHours,
            isVisible: e.row.data.isVisible,
            interactions: e.row.data.interactions.map(interaction=> interaction.interactionId),
            validStates: e.row.data.validStates.map(validState=> validState.stateId)

        });
        setDataDialog({title: "Editar Taxonomia", selectedId:e.row.data.taxonomyId, open: true, operation: "edit"})  
    };

    function handleDeleteDialogOpen({row}){
        setDataDialog({title: "Remover Taxonomia", selectedId: row.data.taxonomyId, open: true, operation: "delete"})  
    }

    const columnsTaxonomy = [
        <Column sortIndex={1} allowEditing={false} key={"taxonomy-1"} dataField="taxonomyId" width={75} caption="Id"/>, 
        <Column key={"taxonomy-2"} dataField="level_1" caption="Taxonomia N1"
        lookup={{multiple: false, allowClearing: false, dataSource: taxonomyDescriptions, displayExpr: "value", valueExpr: "value"}}
        />, 
        <Column key={"taxonomy-3"} dataField="level_2" caption="Taxonomia N2"
        lookup={{multiple: false, allowClearing: false, dataSource: taxonomyDescriptions, displayExpr: "value", valueExpr: "value"}}
        />, 
        <Column key={"taxonomy-4"} dataField="level_3" caption="Taxonomia N3"
        lookup={{multiple: false, allowClearing: false, dataSource: taxonomyDescriptions, displayExpr: "value", valueExpr: "value"}}
        />, 
        <Column key={"taxonomy-5"} dataField="level_4" caption="Taxonomia N4"
        lookup={{multiple: false, allowClearing: false, dataSource: taxonomyDescriptions, displayExpr: "value", valueExpr: "value"}}
        />, 
        <Column key={"taxonomy-6"} dataField={"interactions"} caption="Códigos de interação" calculateDisplayValue={handleCalculateInteractionCellDisplayValue} lookup={{multiple: true, allowClearing: true, dataSource: interactions, displayExpr: "interactionCode", valueExpr: "interactionId"}}/>,
        <Column key={"taxonomy-7"} dataField={"validStates"} caption="Status válidos" calculateDisplayValue={handleCalculateStateCellDisplayValue}
        lookup={{multiple: true, allowClearing: false, dataSource: caseStates, displayExpr: "description", valueExpr: "stateId"}}
        />,
        
        <Column key={"taxonomy-8"} dataField="slaHours" caption="SLA"/>, 

        <Column key={"taxonomy-9"} width={100} dataField="isVisible" caption="Visível"/>, 
        <Column key={"acciones"} width={100} type="buttons">
            <Button onClick = { handleEditDialogOpen } hint={ "Editar" } icon = "edit" style={{ marginRight: '10px' }} />
            <Button onClick = { handleDeleteDialogOpen } hint={ "Remover" } icon = "trash" style={{ marginRight: '10px' }} />
        </Column>
    ]

    const customSearchFields =  <div style={{display: "flex", alignItems: "center", columnGap: "6px", marginLeft: "6px"}}>
        <SelectBox showClearButton placeholder="Nível 1" onValueChanged={(e)=> {onFilterChange(e.value, 2); filterLevel2.current.instance.reset()}} searchEnabled dataSource={filterOptions.level_1} displayExpr="value" valueExpr={"key"} />
        <SelectBox showClearButton ref={filterLevel2} placeholder="Nível 2" onValueChanged={(e)=> {onFilterChange(e.value, 3); filterLevel3.current.instance.reset()}} disabled={!filterValues.taxonomyLevel_1} searchEnabled dataSource={filterOptions.level_2} displayExpr="value" valueExpr={"key"} />
        <SelectBox showClearButton ref={filterLevel3} placeholder="Nível 3" onValueChanged={(e)=> {onFilterChange(e.value, 4); filterLevel4.current.instance.reset()}} disabled={!filterValues.taxonomyLevel_2} searchEnabled dataSource={filterOptions.level_3} displayExpr="value" valueExpr={"key"} />
        <SelectBox showClearButton ref={filterLevel4} placeholder="Nível 4" onValueChanged={(e)=> onFilterChange(e.value, 5)} disabled={!filterValues.taxonomyLevel_3} searchEnabled dataSource={filterOptions.level_4} displayExpr="value" valueExpr={"key"} />
        
    </div>
    
    const customItemCreating = (args) => {
        if (!args.text) {
          args.customItem = null;
          return;
        }
        args.customItem = {key: createTaxonomyKeysFromDescription(args.text), value: args.text}
    }

    function createTaxonomyKeysFromDescription(string)
        {
            return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
		                    .replace(/([^\w]+|\s+)/g, '_') // Replace space and other characters by hyphen
		                    .replace(/\-\-+/g, '_')	// Replaces multiple hyphens by one hyphen
		                    .replace(/(^-+|-+$)/g, '')
                            .toUpperCase()
        }

    return (
        <>
        <AdminDialog dialogSize={{height: "100%"}} operation = { operation } open = { open } onClose = { handleDialogClose } title = {title} 
                data = { data } handleOnClick = { onSubmitOperation }>
                { operation === 'delete'
                    ?   <Typography>
                            {`A taxonomia ${selectedId} será removida.`}
                        </Typography>
                    : 
                        <>                  
                            <InputWrapper classes = {classes} label = {labelTaxonomyLevel1}>
                                <SelectBox
                                    name ="taxonomyLevel1"
                                    dataSource = { taxonomyDescriptions }
                                    showClearButton = { true }
                                    value = { taxonomyForm.taxonomyLevel1 }
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}
                                    displayExpr = { "value" }
                                    valueExpr = { "value" }
                                    onValueChanged = { (e) => handleChangeTaxonomy("taxonomyLevel1", e, 2) }
                                    searchEnabled = { true }
                                    placeholder="Selecione ou digite..."
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {labelTaxonomyLevel2}>
                                <SelectBox
                                    name = "taxonomyLevel2"
                                    dataSource = { taxonomyDescriptions }
                                    showClearButton = { true }
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}
                                    disabled={!taxonomyForm.taxonomyLevel1}
                                    value = { taxonomyForm.taxonomyLevel2 }
                                    displayExpr = { "value" }
                                    valueExpr = { "value" }
                                    onValueChanged = { (e) => handleChangeTaxonomy("taxonomyLevel2", e, 3) }
                                    searchEnabled = { true }
                                    placeholder="Selecione ou digite..."
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {labelTaxonomyLevel3}>
                                <SelectBox
                                    name = "taxonomyLevel3"
                                    dataSource = { taxonomyDescriptions }
                                    showClearButton = { true }
                                    disabled={!taxonomyForm.taxonomyLevel2}
                                    value = { taxonomyForm.taxonomyLevel3 }
                                    displayExpr = { "value" }
                                    valueExpr = { "value" }
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}
                                    onValueChanged = { (e) => handleChangeTaxonomy("taxonomyLevel3", e, 4) }
                                    searchEnabled = { true }
                                    placeholder="Selecione ou digite..."
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {labelTaxonomyLevel4}>
                                <SelectBox
                                    name = "taxonomyLevel4"
                                    dataSource = { taxonomyDescriptions }
                                    showClearButton = { true }
                                    acceptCustomValue
                                    onCustomItemCreating={customItemCreating}
                                    disabled={!taxonomyForm.taxonomyLevel3}
                                    value = { taxonomyForm.taxonomyLevel4 }
                                    displayExpr = { "value" }
                                    valueExpr = { "value" }
                                    onValueChanged = { (e) => onChange("taxonomyLevel4", e.value) }
                                    searchEnabled = { true }
                                    placeholder="Selecione ou digite..."
                                >
                                </SelectBox>
                            </InputWrapper>
                            <InputWrapper classes = {classes}  label={labelInteraction}>
                                <TagBox
                                    dataSource = { interactions}
                                    showClearButton = { true }
                                    defaultValue = {taxonomyForm.interactions}
                                    displayExpr = { "interactionCode" }
                                    valueExpr = { "interactionId" }
                                    onValueChanged =  {(e)=>{handleEditInteractions(e.value)}}
                                    searchEnabled = { true }
                                    hideSelectedItems
                                    placeholder="Selecione..."
                                />
                            </InputWrapper>
                            <InputWrapper classes = {classes}  label={labelValidStates}>
                                <TagBox
                                    dataSource = { caseStates}
                                    showClearButton = { false }
                                    defaultValue = {taxonomyForm.validStates}
                                    displayExpr = { "description" }
                                    valueExpr = { "stateId" }
                                    onValueChanged =  {(e)=>{handleEditValidStates(e.value)}}
                                    searchEnabled = { true }
                                    hideSelectedItems
                                    placeholder="Selecione..."
                                />
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {labelSLA}>
                                <NumberBox 
                                    name = "slaHours"
                                    value = { taxonomyForm.slaHours }
                                    onValueChanged = { (e) => onChange("slaHours", e.value) }
                                />
                            </InputWrapper>
                            <InputWrapper classes = {classes} label = {labelVisible}>
                                <CheckBox 
                                    name = "isVisible"
                                    value = { taxonomyForm.isVisible }
                                    onValueChanged = { (e) => onChange("isVisible", e.value) }
                                >
                                </CheckBox>
                            </InputWrapper>
                        </>
            }
        </AdminDialog>
            <AdminTable loading = { loading } dataDialog = { dataDialog} getData = { getTaxonomiesAdmin } 
                dataSource = { taxonomies } columnasTabla = { columnsTaxonomy} numElements = { numElements } 
                customEdition
                customCreation
                sectionTitle={"Taxonomias"}
                onCreate={handleNewDialogOpen}
                customSearchFields={customSearchFields}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </>
    )
}

export default TaxonomyManagement
